import type { ReactElement } from "react";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import CrmFilterChipsItems from "app/pages/sales-intelligence/modules/leads-search-filters/components/CrmFilterChipsItems/CrmFilterChipsItems";
import { useCrmFilterResultLogic } from "app/pages/sales-intelligence/modules/leads-search-filters/hooks/useCrmFilterResultLogic";
import type CrmFieldsFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/CrmFieldsFilter/CrmFieldsFilter";
import { inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

const CrmFieldsFilterResultContainer = ({
    filter: {
        options: { integrationName, fields },
    },
    value,
    isExpanded,
    isActionEnabled = true,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<CrmFieldsFilter>): ReactElement | null => {
    const { fieldLabels, onDelete } = useCrmFilterResultLogic({
        integrationName,
        fields,
        value,
        onFilterUpdate,
        inclusion: inclusionOptionMap.includeOnly,
        onFilterValueRemove,
    });

    if (!value) {
        return null;
    }

    return (
        <FilterResultContainer>
            <CrmFilterChipsItems
                values={value?.listFieldsFilters}
                fields={fields}
                fieldLabels={fieldLabels}
                isExpanded={isExpanded}
                hideActionButton={!isActionEnabled}
                onDelete={onDelete}
            />
        </FilterResultContainer>
    );
};

export default CrmFieldsFilterResultContainer;
